import React from 'react';
import { Logo } from './Logo';
import { ThemeToggle } from './ThemeToggle';

export function Header() {
  return (
    <header className="flex h-16 w-full items-center justify-between border-b border-outline bg-surface px-4">
      <Logo />
      <div className="flex items-center gap-2">
        <ThemeToggle />
      </div>
    </header>
  );
}
